import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {MonthPickerComponentModel} from '../../../../components/forms/controls/monthpicker/month-picker.component';
import {ActivatedRoute} from '@angular/router';
import {MilitaryExperienceService} from '../../../../domain/model/work/military/military-experience.service';
import {MilitaryExperience, Statuses} from '../../../../domain/model/work/military/military-experience.model';
import {FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {Model} from '../../../../domain/model/common/model.class';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;

type ActiveStatuses = 'Active';
type DischargeStatuses = 'Honorable/Discharge' | 'Dishonorable/Discharge';

@Component({
    template: require('./military-experience-screen.component.html')
})
export class MilitaryExperienceScreenComponent {

    constructor(readonly modelService: MilitaryExperienceService,
                readonly route: ActivatedRoute,
                readonly fileLocationFactory: FileLocationFactory) {

        this.stepScreenModel.dataModel$.subscribe(() => this.handleUpToPresentDurationChange());
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    private readonly _activeStatuses: ActiveStatuses[] = ['Active'];
    private readonly _dischargeStatuses: DischargeStatuses[] = ['Honorable/Discharge', 'Dishonorable/Discharge'];
    statuses: Statuses[] = [
        'Active',
        'Honorable/Discharge',
        'Dishonorable/Discharge'
    ];
    durationDateConstrains = {
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(1, 'year')
    };
    durationFromMonthPickerModel = new MonthPickerComponentModel(this.durationDateConstrains);
    durationToMonthPickerModel = new MonthPickerComponentModel(this.durationDateConstrains);

    dischargeDocumentFileLocation = this.fileLocationFactory.create('militaryExperience', 'currentUser', new ProjectionInformation('dischargeDocument'));

    stepScreenModel = new StepScreenModel<MilitaryExperience>({
        initialDataModel: new MilitaryExperience(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this.modelService.getCurrentUserModel();
        },
        _submitDataFn: (model: MilitaryExperience) => {
            return this.modelService.updateCurrentUserModel(model);
        },
        _hasYesNoQuestion: () => this.modelService.doesCurrentUserModelExist().map(r => !r)
    });

    get model(): MilitaryExperience {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleUpToPresentDurationChange() {
        const value = this.model.duration.upToPresent;
        if (value !== undefined) {
            if (value) this.model.status = 'Active';
            else if (this.model.status === 'Active') this.model.status = undefined;
            this.statuses = value ? this._activeStatuses : this._dischargeStatuses;
        }
        if (value) this.model.duration.to = undefined;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/work/steps/military/military-experience-screen.component.ts